<style scoped>

</style>

<template>
  <span>
    <slot slot-scope="scope"></slot>
    <mu-dialog :title="$t('button.share')" scrollable max-width="100%" :esc-press-close="false" :overlay-close="false" :open.sync="sharing">
      <mu-text-field icon="file_copy" :value="stringMediaUrl" multi-line :rows="2" full-width @focus="onActionCopy(stringMediaUrl)"/>
      <mu-text-field icon="code" :value="embedCode" multi-line :rows="4" full-width @focus="onActionCopy(embedCode)"></mu-text-field>
      <mu-form :model="data">
        <mu-checkbox v-model="modelAllowFullscreen" :label="$t('embed.allowFullscreen')"></mu-checkbox>
        <mu-row>
        <mu-col>
        <mu-form-item prop="input" :label="$t('embed.width')">
          <mu-text-field v-model="modelWidth" type="number"></mu-text-field>
        </mu-form-item>
        </mu-col>
        <mu-col>
        <mu-form-item prop="input" :label="$t('embed.height')">
          <mu-text-field v-model="modelHeight" type="number"></mu-text-field>
        </mu-form-item>
        </mu-col>
        </mu-row>
      </mu-form>
      <mu-button slot="actions" flat color="primary" @click="onActionCancel"><mu-icon value="close"></mu-icon> {{$t('prompt.cancel')}}</mu-button>
    </mu-dialog>
  </span>
</template>

<script>

export default {
  name: 'ShareMedia',
  props: {
    value: {
      type: Object,
      default() {
        return {
          name: "",
          content: "",
          description: ""
        };
      }
    },
    sharing: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    },
  },
  data() {
    return {
      data: JSON.parse(JSON.stringify(this.value)),
      
      modelAllowFullscreen: true,
      modelWidth: 640,
      modelHeight: 400,
    }
  },
  computed: {
    stringMediaUrl() {
      return process.env.VUE_APP_VOX_URL_FRONTEND + "media/" + this.data._id;
    },
    embedCode() {
      var str = '<iframe src="' + process.env.VUE_APP_VOX_URL_FRONTEND + 'embed/'+ this.data._id + '" frameBorder="0" width="' + this.modelWidth + '" height="' + this.modelHeight + '"';
      if(this.modelAllowFullscreen) {
        str += ' allowfullscreen';
      }
      str += '></iframe>';
      return str;
    },
  },
  watch: {
    data: {
      handler(newValue) {
        this.$emit('input', newValue);
      },
      deep: true
    },
    value: {
      handler(newValue) {
        if(typeof this.data._id !== 'undefined' && this.data._id !== newValue._id) {
          this.data = JSON.parse(JSON.stringify(this.value))
        }
      },
      deep: true
    },
  },
  methods: {
    onActionCancel() {
      this.$emit('cancel');
    },
    onActionCopy(str) {
      var textArea = document.createElement("textarea");
      document.body.appendChild(textArea);

      textArea.value = str;
      textArea.focus();
      textArea.select();

      try {
        document.execCommand('copy');
        this.$toast.success(this.$t('toast.share.success'));
      } catch (err) {
        this.$toast.error(this.$t('toast.share.fail'));
      }

      document.body.removeChild(textArea);
    },
  }
}
</script>
